import { useMutation } from "@tanstack/react-query";
import { generateMedia, MediaGenerateRequest } from "#/api/mediaReference.api";
import { useToast } from "#/hooks/ToastContext";

export function useGenerateMedia() {
  const { showToast } = useToast();

  return useMutation({
    mutationFn: (payload: MediaGenerateRequest) => generateMedia(payload),
    onSuccess: () => {
      showToast("Generation queued", "success");
    },
    onError: (error) => {
      showToast(
        error instanceof Error ? error.message : "Failed to queue generation",
        "error"
      );
    },
  });
}
